import { render } from "./KioskBranded.vue?vue&type=template&id=cd8bcc6e&scoped=true&ts=true"
import script from "./KioskBranded.vue?vue&type=script&lang=ts"
export * from "./KioskBranded.vue?vue&type=script&lang=ts"

import "./KioskBranded.vue?vue&type=style&index=0&id=cd8bcc6e&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd8bcc6e"]])

export default __exports__